let storeInstance = null;

/**
 * Sets the store instance. This is called once in `main.js`.
 * @param {Object} store - The Vuex store instance.
 */
export function setStore(store) {
    storeInstance = store;
}

export function getStore() {
    return storeInstance;
}